/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { setLoading } from './loading'
import { API } from 'src/services/config'

interface IBreedState {
  idRaca: string
  descricao: string
}

export interface BreedState {
  loading: boolean
  list: Array<IBreedState>
}

const customModule = '@BREED'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`
}

const initialState: BreedState = {
  loading: false,
  list: []
}

export const breedReducer: Reducer<BreedState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, isLoading: true }
    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }
    default:
      return state
  }
}

export const getBreedList = () => ({ type: GET.REQUEST })

const ROUTE = '/entity/Raca'

// eslint-disable-next-line
function* get({ payload }: SagaAction<string>) {
  try {
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}`)
    const dataOrdered = data.sort((a: any, b: any) => a.descricao.localeCompare(b.descricao))
    yield put({ type: GET.SUCCESS, payload: dataOrdered })
    yield put(setLoading(false))
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar lista de raça. Tente novamente.'
    toast.error(message)
    yield put(setLoading(false))
  }
}

export const breedSaga = all([takeLatest(GET.REQUEST, get)])
